import {useState, useEffect, useContext} from 'react';
import { PaperAirplaneIcon } from '@heroicons/react/24/solid';
import { AuthContext } from '../AuthContext';
import { formatDistanceToNow } from 'date-fns';



export default function ProjectChat({projectId}) {

    const [instructionText, setInstructionText] = useState('');
    const [taskMessages, setTaskMessages] = useState([]);
    const [sendMessage, setSendMessage] = useState(false);

    const user = useContext(AuthContext);

    const name = user.email

        const isOwnMessage = (messageAuthor) =>
            String(messageAuthor || '').trim().toLowerCase() === String(name || '').trim().toLowerCase();


const handleSendMessage = async (sendMessage) => {

    if (instructionText.trim() === '') return; // Prevent sending empty messages

try {

    const response = await fetch(`https://api.insightos.co.uk/api/projectchat/${projectId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        


        body: JSON.stringify({
            Content: instructionText,
            Author: name,
        }),

    });

    if (!response.ok) {
        throw new Error('Network response was not ok');
    }

    const data = await response.json();
    console.log('Message sent successfully:', data);

} catch (error) {
    console.error('Error sending message:', error);
}

    setInstructionText(''); // Clear the input field after sending

    setSendMessage(!sendMessage); // Trigger re-render to show the new message

    // Fetch the updated messages after sending a new one


    };


    useEffect(() => {
        const fetchMessages = async () => {
            try {
                const response = await fetch(`https://api.insightos.co.uk/api/projectchat/${projectId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                      },
                      credentials: 'include',
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                console.log('Fetched messages:', data.data);
                setTaskMessages(data.data);
            } catch (error) {
                console.error('Error fetching messages:', error);
            }
        };

        fetchMessages();
    }
    , [sendMessage, projectId]); // Re-fetch messages when sendMessage changes



    
















    return (
        <section className="w-full mt-6 sm:mt-8">
            <div className="rounded-2xl border border-indigo-200/70 bg-gradient-to-r from-indigo-100/80 via-white/85 to-purple-100/80 p-3 sm:p-4 backdrop-blur-xl shadow-[0_12px_30px_rgba(99,102,241,0.16)]">
                <div className="rounded-2xl border border-indigo-200/70 bg-white/85 backdrop-blur-xl shadow-[0_12px_24px_rgba(99,102,241,0.12)] overflow-hidden">
                    <header className="flex items-center justify-between gap-3 px-4 sm:px-6 py-3 sm:py-4 border-b border-indigo-200/70 bg-gradient-to-r from-indigo-900 via-sky-600 to-emerald-500">
                        <div>
                            <h2 className="text-base sm:text-lg font-semibold text-white">Project Chat Room</h2>
                            <p className="text-xs text-white/80 mt-0.5">Team conversation for this project</p>
                        </div>
                        <div className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/20 px-2.5 py-1 text-xs font-semibold text-white">
                            <span className="h-2 w-2 rounded-full bg-emerald-300 animate-pulse"></span>
                            Live
                        </div>
                    </header>

                    <div className="p-3 sm:p-4 md:p-5">
                        <div className="h-[19rem] sm:h-[24rem] overflow-y-auto rounded-2xl border border-indigo-200/70 bg-gradient-to-b from-white/90 to-indigo-50/70 p-3 sm:p-4 shadow-inner">
                            {taskMessages.length > 0 ? (
                                <ul className="space-y-3 sm:space-y-4">
                                    {taskMessages.map((message, index) => {
                                        const mine = isOwnMessage(message.Author);
                                        return (
                                            <li key={index} className={`flex ${mine ? 'justify-end' : 'justify-start'}`}>
                                                <div className={`max-w-[92%] sm:max-w-[78%] rounded-2xl px-3 sm:px-4 py-2.5 sm:py-3 border shadow-[0_10px_18px_rgba(30,41,59,0.14)] ${
                                                    mine
                                                      ? 'border-indigo-200/70 bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 text-white'
                                                      : 'border-indigo-200/70 bg-white/90 text-indigo-950'
                                                }`}>
                                                    <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs">
                                                        <span className={`font-semibold ${mine ? 'text-white' : 'text-indigo-900'}`}>
                                                            {message.Author || 'Unknown'}
                                                        </span>
                                                        <span className={`${mine ? 'text-white/80' : 'text-indigo-500'}`}>
                                                            {formatDistanceToNow(new Date(message.CreatedAt), { addSuffix: true })}
                                                        </span>
                                                    </div>
                                                    <p className={`mt-1.5 text-sm break-words ${mine ? 'text-white' : 'text-indigo-800'}`}>
                                                        {message.Content}
                                                    </p>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            ) : (
                                <div className="h-full flex items-center justify-center rounded-xl border border-dashed border-indigo-200/70 bg-white/70">
                                    <p className="text-sm text-indigo-500">No messages yet. Start the conversation.</p>
                                </div>
                            )}
                        </div>

                        <div className="mt-3 sm:mt-4 rounded-2xl border border-indigo-200/70 bg-white/90 p-2 sm:p-3 shadow-[0_10px_18px_rgba(30,41,59,0.1)]">
                            <div className="relative">
                                <textarea
                                    onChange={e => setInstructionText(e.target.value)}
                                    value={instructionText}
                                    className="w-full h-20 sm:h-24 resize-none rounded-xl border border-indigo-200/70 bg-white/85 p-3 pr-12 text-sm text-indigo-900 placeholder-indigo-400 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400"
                                    placeholder="Write a message to your project team..."
                                />
                                <button
                                    onClick={() => handleSendMessage(sendMessage)}
                                    data-component="project-chat"
                                    data-feature="send_message_post"
                                    data-project-id={projectId}
                                    className="absolute bottom-2 right-2 inline-flex items-center justify-center rounded-xl border border-white/20 bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 p-2.5 text-white shadow-lg shadow-indigo-950/35 transition hover:from-indigo-800/95 hover:to-indigo-600/95"
                                >
                                    <PaperAirplaneIcon className="h-4 w-4 sm:h-5 sm:w-5" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}


